<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>

export default {
    name: 'App',
    data() {
        return {
            meta: [{                 
                name: 'keyWords',
                content: 'My Example App'
            }],
        }
    },
    methods:{
        //切换系统更换token
        changeToken() {
        let token = COOKIE.get('token')
        if(token){
            let tokenList = token.split('.');
            let session=JSON.parse(BASE64.decoder(tokenList[1])).zstackSessionId
            if(!session){
                let loading = this.$loading({
                    lock: true,
                    text: '加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let fullPath = this.$route.fullPath
                this.axios.put('/cloud/ZStack/switch')
                .then(response => {
                    loading.close()
                    if(response.data.code =='200'){
                        let token = response.data.data.token;
                        let tokenList = token.split('.');
                        let time=JSON.parse(BASE64.decoder(tokenList[1])).exp
                        window.localStorage.setItem('menu',JSON.stringify(response.data.data.loginUserInfo.loginUserMenu))
                        window.localStorage.setItem('info',JSON.stringify(BASE64.decoder(tokenList[1])))
                        window.localStorage.setItem('initialization',response.data.data.initialization)
                        window.localStorage.setItem('userEmail',response.data.data.loginUserInfo.loginUserInfo.userEmail)
                        COOKIE.del('token');
                        COOKIE.set('token',token,time)
                        this.$router.push(fullPath)
                    }else{
                        this.$message.error('系统更换错误！');
                    }
                })
            }
        }
        }
    },
    metaInfo() {
        return {
            meta: this.meta
        }
    },
    mounted: function() {
        this.changeToken()
        var height = window.screen.height
        if(height>650){
            document.body.style.height='100%'
        }
    }
};
</script>

<style>
#app {
    font-family: "Helvetica Neue", "Luxi Sans", "DejaVu Sans", Tahoma, "Hiragino Sans GB", STHeiti, "Microsoft YaHei", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #2c3e50;
    height: 100%
}
</style>



// WEBPACK FOOTER //
// src/App.vue